import { isEmpty } from '@chegg/utils';
import { saveConfigs } from '../../ConfigState/ConfigState.actions';
/**
 * Util to catch the parameters received from drop in payment to open the billdesk modal
 * @param params
 * @returns
 */
export var openBilldeskCommand = function openBilldeskCommand(params) {
  var command = params.command,
    dispatch = params.dispatch;
  if (!command.data || isEmpty(command.data)) return;
  var upiParams = command.data;
  dispatch(saveConfigs({
    upiParams: upiParams
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/openBilldeskCommand.js
// module id = 4526
// module chunks = 11